package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.roster.RosterStatusDto
import com.evoapps.evoshift.domain.model.RosterStatus

class RosterStatusMapper {

    fun toDomain(dto: RosterStatusDto): RosterStatus {
        return when (dto) {
            RosterStatusDto.SKELETON -> RosterStatus.SKELETON
            RosterStatusDto.DRAFT -> RosterStatus.DRAFT
            RosterStatusDto.PUBLISHED -> RosterStatus.PUBLISHED
            RosterStatusDto.LOCKED -> RosterStatus.LOCKED
            RosterStatusDto.ARCHIVED -> RosterStatus.ARCHIVED
        }
    }

    fun toDto(domain: RosterStatus): RosterStatusDto {
        return when (domain) {
            RosterStatus.SKELETON -> RosterStatusDto.SKELETON
            RosterStatus.DRAFT -> RosterStatusDto.DRAFT
            RosterStatus.PUBLISHED -> RosterStatusDto.PUBLISHED
            RosterStatus.LOCKED -> RosterStatusDto.LOCKED
            RosterStatus.ARCHIVED -> RosterStatusDto.ARCHIVED
        }
    }
}
